/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnderReviewRouteImport } from './routes/under-review'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as AuthLayoutRouteImport } from './routes/_auth-layout'
import { Route as IndexRouteImport } from './routes/index'
import { Route as publicTermsAndConditionsRouteImport } from './routes/(public)/terms-and-conditions'
import { Route as publicPrivacyPolicyRouteImport } from './routes/(public)/privacy-policy'
import { Route as LayoutprivateProfileRouteImport } from './routes/_layout.(private)/profile'
import { Route as LayoutprivateMyStatementsRouteImport } from './routes/_layout.(private)/my-statements'
import { Route as LayoutprivateHomeRouteImport } from './routes/_layout.(private)/home'
import { Route as AuthLayoutauthSignInRouteImport } from './routes/_auth-layout.(auth)/sign-in'
import { Route as AuthLayoutauthRegisterRouteImport } from './routes/_auth-layout.(auth)/register'
import { Route as AuthLayoutauthForgotPasswordRouteImport } from './routes/_auth-layout.(auth)/forgot-password'
import { Route as LayoutprivateTreatmentsIndexRouteImport } from './routes/_layout.(private)/treatments/index'
import { Route as LayoutprivateNewTreatmentsIndexRouteImport } from './routes/_layout.(private)/new-treatments/index'
import { Route as LayoutprivateNewMedicationsIndexRouteImport } from './routes/_layout.(private)/new-medications/index'
import { Route as LayoutprivateMyTreatmentsIndexRouteImport } from './routes/_layout.(private)/my-treatments/index'
import { Route as LayoutprivateMyMedicationsIndexRouteImport } from './routes/_layout.(private)/my-medications/index'
import { Route as LayoutprivateMedicationsIndexRouteImport } from './routes/_layout.(private)/medications/index'
import { Route as LayoutprivateTreatmentsIdRouteImport } from './routes/_layout.(private)/treatments/$id'
import { Route as LayoutprivateNewTreatmentsIdRouteImport } from './routes/_layout.(private)/new-treatments/$id'
import { Route as LayoutprivateNewMedicationsIdRouteImport } from './routes/_layout.(private)/new-medications/$id'
import { Route as LayoutprivateMedicationsIdRouteImport } from './routes/_layout.(private)/medications/$id'
import { Route as LayoutprivateMyTreatmentsIdNewDetailsRouteImport } from './routes/_layout.(private)/my-treatments/$id/new-details'
import { Route as LayoutprivateMyTreatmentsIdEditDetailsRouteImport } from './routes/_layout.(private)/my-treatments/$id/edit-details'
import { Route as LayoutprivateMyMedicationsIdNewDetailsRouteImport } from './routes/_layout.(private)/my-medications/$id/new-details'
import { Route as LayoutprivateMyMedicationsIdEditDetailsRouteImport } from './routes/_layout.(private)/my-medications/$id/edit-details'
import { Route as LayoutprivateMyTreatmentsIdNewIndexRouteImport } from './routes/_layout.(private)/my-treatments/$id/new/index'
import { Route as LayoutprivateMyTreatmentsIdEditIndexRouteImport } from './routes/_layout.(private)/my-treatments/$id/edit/index'
import { Route as LayoutprivateMyMedicationsIdNewIndexRouteImport } from './routes/_layout.(private)/my-medications/$id/new/index'
import { Route as LayoutprivateMyMedicationsIdEditIndexRouteImport } from './routes/_layout.(private)/my-medications/$id/edit/index'

const UnderReviewRoute = UnderReviewRouteImport.update({
  id: '/under-review',
  path: '/under-review',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLayoutRoute = AuthLayoutRouteImport.update({
  id: '/_auth-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const publicTermsAndConditionsRoute =
  publicTermsAndConditionsRouteImport.update({
    id: '/(public)/terms-and-conditions',
    path: '/terms-and-conditions',
    getParentRoute: () => rootRouteImport,
  } as any)
const publicPrivacyPolicyRoute = publicPrivacyPolicyRouteImport.update({
  id: '/(public)/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutprivateProfileRoute = LayoutprivateProfileRouteImport.update({
  id: '/(private)/profile',
  path: '/profile',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutprivateMyStatementsRoute =
  LayoutprivateMyStatementsRouteImport.update({
    id: '/(private)/my-statements',
    path: '/my-statements',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateHomeRoute = LayoutprivateHomeRouteImport.update({
  id: '/(private)/home',
  path: '/home',
  getParentRoute: () => LayoutRoute,
} as any)
const AuthLayoutauthSignInRoute = AuthLayoutauthSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthLayoutauthRegisterRoute = AuthLayoutauthRegisterRouteImport.update({
  id: '/(auth)/register',
  path: '/register',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthLayoutauthForgotPasswordRoute =
  AuthLayoutauthForgotPasswordRouteImport.update({
    id: '/(auth)/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => AuthLayoutRoute,
  } as any)
const LayoutprivateTreatmentsIndexRoute =
  LayoutprivateTreatmentsIndexRouteImport.update({
    id: '/(private)/treatments/',
    path: '/treatments/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateNewTreatmentsIndexRoute =
  LayoutprivateNewTreatmentsIndexRouteImport.update({
    id: '/(private)/new-treatments/',
    path: '/new-treatments/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateNewMedicationsIndexRoute =
  LayoutprivateNewMedicationsIndexRouteImport.update({
    id: '/(private)/new-medications/',
    path: '/new-medications/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateMyTreatmentsIndexRoute =
  LayoutprivateMyTreatmentsIndexRouteImport.update({
    id: '/(private)/my-treatments/',
    path: '/my-treatments/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateMyMedicationsIndexRoute =
  LayoutprivateMyMedicationsIndexRouteImport.update({
    id: '/(private)/my-medications/',
    path: '/my-medications/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateMedicationsIndexRoute =
  LayoutprivateMedicationsIndexRouteImport.update({
    id: '/(private)/medications/',
    path: '/medications/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateTreatmentsIdRoute =
  LayoutprivateTreatmentsIdRouteImport.update({
    id: '/(private)/treatments/$id',
    path: '/treatments/$id',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateNewTreatmentsIdRoute =
  LayoutprivateNewTreatmentsIdRouteImport.update({
    id: '/(private)/new-treatments/$id',
    path: '/new-treatments/$id',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateNewMedicationsIdRoute =
  LayoutprivateNewMedicationsIdRouteImport.update({
    id: '/(private)/new-medications/$id',
    path: '/new-medications/$id',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateMedicationsIdRoute =
  LayoutprivateMedicationsIdRouteImport.update({
    id: '/(private)/medications/$id',
    path: '/medications/$id',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateMyTreatmentsIdNewDetailsRoute =
  LayoutprivateMyTreatmentsIdNewDetailsRouteImport.update({
    id: '/(private)/my-treatments/$id/new-details',
    path: '/my-treatments/$id/new-details',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateMyTreatmentsIdEditDetailsRoute =
  LayoutprivateMyTreatmentsIdEditDetailsRouteImport.update({
    id: '/(private)/my-treatments/$id/edit-details',
    path: '/my-treatments/$id/edit-details',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateMyMedicationsIdNewDetailsRoute =
  LayoutprivateMyMedicationsIdNewDetailsRouteImport.update({
    id: '/(private)/my-medications/$id/new-details',
    path: '/my-medications/$id/new-details',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateMyMedicationsIdEditDetailsRoute =
  LayoutprivateMyMedicationsIdEditDetailsRouteImport.update({
    id: '/(private)/my-medications/$id/edit-details',
    path: '/my-medications/$id/edit-details',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateMyTreatmentsIdNewIndexRoute =
  LayoutprivateMyTreatmentsIdNewIndexRouteImport.update({
    id: '/(private)/my-treatments/$id/new/',
    path: '/my-treatments/$id/new/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateMyTreatmentsIdEditIndexRoute =
  LayoutprivateMyTreatmentsIdEditIndexRouteImport.update({
    id: '/(private)/my-treatments/$id/edit/',
    path: '/my-treatments/$id/edit/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateMyMedicationsIdNewIndexRoute =
  LayoutprivateMyMedicationsIdNewIndexRouteImport.update({
    id: '/(private)/my-medications/$id/new/',
    path: '/my-medications/$id/new/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutprivateMyMedicationsIdEditIndexRoute =
  LayoutprivateMyMedicationsIdEditIndexRouteImport.update({
    id: '/(private)/my-medications/$id/edit/',
    path: '/my-medications/$id/edit/',
    getParentRoute: () => LayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/under-review': typeof UnderReviewRoute
  '/privacy-policy': typeof publicPrivacyPolicyRoute
  '/terms-and-conditions': typeof publicTermsAndConditionsRoute
  '/forgot-password': typeof AuthLayoutauthForgotPasswordRoute
  '/register': typeof AuthLayoutauthRegisterRoute
  '/sign-in': typeof AuthLayoutauthSignInRoute
  '/home': typeof LayoutprivateHomeRoute
  '/my-statements': typeof LayoutprivateMyStatementsRoute
  '/profile': typeof LayoutprivateProfileRoute
  '/medications/$id': typeof LayoutprivateMedicationsIdRoute
  '/new-medications/$id': typeof LayoutprivateNewMedicationsIdRoute
  '/new-treatments/$id': typeof LayoutprivateNewTreatmentsIdRoute
  '/treatments/$id': typeof LayoutprivateTreatmentsIdRoute
  '/medications': typeof LayoutprivateMedicationsIndexRoute
  '/my-medications': typeof LayoutprivateMyMedicationsIndexRoute
  '/my-treatments': typeof LayoutprivateMyTreatmentsIndexRoute
  '/new-medications': typeof LayoutprivateNewMedicationsIndexRoute
  '/new-treatments': typeof LayoutprivateNewTreatmentsIndexRoute
  '/treatments': typeof LayoutprivateTreatmentsIndexRoute
  '/my-medications/$id/edit-details': typeof LayoutprivateMyMedicationsIdEditDetailsRoute
  '/my-medications/$id/new-details': typeof LayoutprivateMyMedicationsIdNewDetailsRoute
  '/my-treatments/$id/edit-details': typeof LayoutprivateMyTreatmentsIdEditDetailsRoute
  '/my-treatments/$id/new-details': typeof LayoutprivateMyTreatmentsIdNewDetailsRoute
  '/my-medications/$id/edit': typeof LayoutprivateMyMedicationsIdEditIndexRoute
  '/my-medications/$id/new': typeof LayoutprivateMyMedicationsIdNewIndexRoute
  '/my-treatments/$id/edit': typeof LayoutprivateMyTreatmentsIdEditIndexRoute
  '/my-treatments/$id/new': typeof LayoutprivateMyTreatmentsIdNewIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/under-review': typeof UnderReviewRoute
  '/privacy-policy': typeof publicPrivacyPolicyRoute
  '/terms-and-conditions': typeof publicTermsAndConditionsRoute
  '/forgot-password': typeof AuthLayoutauthForgotPasswordRoute
  '/register': typeof AuthLayoutauthRegisterRoute
  '/sign-in': typeof AuthLayoutauthSignInRoute
  '/home': typeof LayoutprivateHomeRoute
  '/my-statements': typeof LayoutprivateMyStatementsRoute
  '/profile': typeof LayoutprivateProfileRoute
  '/medications/$id': typeof LayoutprivateMedicationsIdRoute
  '/new-medications/$id': typeof LayoutprivateNewMedicationsIdRoute
  '/new-treatments/$id': typeof LayoutprivateNewTreatmentsIdRoute
  '/treatments/$id': typeof LayoutprivateTreatmentsIdRoute
  '/medications': typeof LayoutprivateMedicationsIndexRoute
  '/my-medications': typeof LayoutprivateMyMedicationsIndexRoute
  '/my-treatments': typeof LayoutprivateMyTreatmentsIndexRoute
  '/new-medications': typeof LayoutprivateNewMedicationsIndexRoute
  '/new-treatments': typeof LayoutprivateNewTreatmentsIndexRoute
  '/treatments': typeof LayoutprivateTreatmentsIndexRoute
  '/my-medications/$id/edit-details': typeof LayoutprivateMyMedicationsIdEditDetailsRoute
  '/my-medications/$id/new-details': typeof LayoutprivateMyMedicationsIdNewDetailsRoute
  '/my-treatments/$id/edit-details': typeof LayoutprivateMyTreatmentsIdEditDetailsRoute
  '/my-treatments/$id/new-details': typeof LayoutprivateMyTreatmentsIdNewDetailsRoute
  '/my-medications/$id/edit': typeof LayoutprivateMyMedicationsIdEditIndexRoute
  '/my-medications/$id/new': typeof LayoutprivateMyMedicationsIdNewIndexRoute
  '/my-treatments/$id/edit': typeof LayoutprivateMyTreatmentsIdEditIndexRoute
  '/my-treatments/$id/new': typeof LayoutprivateMyTreatmentsIdNewIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth-layout': typeof AuthLayoutRouteWithChildren
  '/_layout': typeof LayoutRouteWithChildren
  '/under-review': typeof UnderReviewRoute
  '/(public)/privacy-policy': typeof publicPrivacyPolicyRoute
  '/(public)/terms-and-conditions': typeof publicTermsAndConditionsRoute
  '/_auth-layout/(auth)/forgot-password': typeof AuthLayoutauthForgotPasswordRoute
  '/_auth-layout/(auth)/register': typeof AuthLayoutauthRegisterRoute
  '/_auth-layout/(auth)/sign-in': typeof AuthLayoutauthSignInRoute
  '/_layout/(private)/home': typeof LayoutprivateHomeRoute
  '/_layout/(private)/my-statements': typeof LayoutprivateMyStatementsRoute
  '/_layout/(private)/profile': typeof LayoutprivateProfileRoute
  '/_layout/(private)/medications/$id': typeof LayoutprivateMedicationsIdRoute
  '/_layout/(private)/new-medications/$id': typeof LayoutprivateNewMedicationsIdRoute
  '/_layout/(private)/new-treatments/$id': typeof LayoutprivateNewTreatmentsIdRoute
  '/_layout/(private)/treatments/$id': typeof LayoutprivateTreatmentsIdRoute
  '/_layout/(private)/medications/': typeof LayoutprivateMedicationsIndexRoute
  '/_layout/(private)/my-medications/': typeof LayoutprivateMyMedicationsIndexRoute
  '/_layout/(private)/my-treatments/': typeof LayoutprivateMyTreatmentsIndexRoute
  '/_layout/(private)/new-medications/': typeof LayoutprivateNewMedicationsIndexRoute
  '/_layout/(private)/new-treatments/': typeof LayoutprivateNewTreatmentsIndexRoute
  '/_layout/(private)/treatments/': typeof LayoutprivateTreatmentsIndexRoute
  '/_layout/(private)/my-medications/$id/edit-details': typeof LayoutprivateMyMedicationsIdEditDetailsRoute
  '/_layout/(private)/my-medications/$id/new-details': typeof LayoutprivateMyMedicationsIdNewDetailsRoute
  '/_layout/(private)/my-treatments/$id/edit-details': typeof LayoutprivateMyTreatmentsIdEditDetailsRoute
  '/_layout/(private)/my-treatments/$id/new-details': typeof LayoutprivateMyTreatmentsIdNewDetailsRoute
  '/_layout/(private)/my-medications/$id/edit/': typeof LayoutprivateMyMedicationsIdEditIndexRoute
  '/_layout/(private)/my-medications/$id/new/': typeof LayoutprivateMyMedicationsIdNewIndexRoute
  '/_layout/(private)/my-treatments/$id/edit/': typeof LayoutprivateMyTreatmentsIdEditIndexRoute
  '/_layout/(private)/my-treatments/$id/new/': typeof LayoutprivateMyTreatmentsIdNewIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/under-review'
    | '/privacy-policy'
    | '/terms-and-conditions'
    | '/forgot-password'
    | '/register'
    | '/sign-in'
    | '/home'
    | '/my-statements'
    | '/profile'
    | '/medications/$id'
    | '/new-medications/$id'
    | '/new-treatments/$id'
    | '/treatments/$id'
    | '/medications'
    | '/my-medications'
    | '/my-treatments'
    | '/new-medications'
    | '/new-treatments'
    | '/treatments'
    | '/my-medications/$id/edit-details'
    | '/my-medications/$id/new-details'
    | '/my-treatments/$id/edit-details'
    | '/my-treatments/$id/new-details'
    | '/my-medications/$id/edit'
    | '/my-medications/$id/new'
    | '/my-treatments/$id/edit'
    | '/my-treatments/$id/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/under-review'
    | '/privacy-policy'
    | '/terms-and-conditions'
    | '/forgot-password'
    | '/register'
    | '/sign-in'
    | '/home'
    | '/my-statements'
    | '/profile'
    | '/medications/$id'
    | '/new-medications/$id'
    | '/new-treatments/$id'
    | '/treatments/$id'
    | '/medications'
    | '/my-medications'
    | '/my-treatments'
    | '/new-medications'
    | '/new-treatments'
    | '/treatments'
    | '/my-medications/$id/edit-details'
    | '/my-medications/$id/new-details'
    | '/my-treatments/$id/edit-details'
    | '/my-treatments/$id/new-details'
    | '/my-medications/$id/edit'
    | '/my-medications/$id/new'
    | '/my-treatments/$id/edit'
    | '/my-treatments/$id/new'
  id:
    | '__root__'
    | '/'
    | '/_auth-layout'
    | '/_layout'
    | '/under-review'
    | '/(public)/privacy-policy'
    | '/(public)/terms-and-conditions'
    | '/_auth-layout/(auth)/forgot-password'
    | '/_auth-layout/(auth)/register'
    | '/_auth-layout/(auth)/sign-in'
    | '/_layout/(private)/home'
    | '/_layout/(private)/my-statements'
    | '/_layout/(private)/profile'
    | '/_layout/(private)/medications/$id'
    | '/_layout/(private)/new-medications/$id'
    | '/_layout/(private)/new-treatments/$id'
    | '/_layout/(private)/treatments/$id'
    | '/_layout/(private)/medications/'
    | '/_layout/(private)/my-medications/'
    | '/_layout/(private)/my-treatments/'
    | '/_layout/(private)/new-medications/'
    | '/_layout/(private)/new-treatments/'
    | '/_layout/(private)/treatments/'
    | '/_layout/(private)/my-medications/$id/edit-details'
    | '/_layout/(private)/my-medications/$id/new-details'
    | '/_layout/(private)/my-treatments/$id/edit-details'
    | '/_layout/(private)/my-treatments/$id/new-details'
    | '/_layout/(private)/my-medications/$id/edit/'
    | '/_layout/(private)/my-medications/$id/new/'
    | '/_layout/(private)/my-treatments/$id/edit/'
    | '/_layout/(private)/my-treatments/$id/new/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthLayoutRoute: typeof AuthLayoutRouteWithChildren
  LayoutRoute: typeof LayoutRouteWithChildren
  UnderReviewRoute: typeof UnderReviewRoute
  publicPrivacyPolicyRoute: typeof publicPrivacyPolicyRoute
  publicTermsAndConditionsRoute: typeof publicTermsAndConditionsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/under-review': {
      id: '/under-review'
      path: '/under-review'
      fullPath: '/under-review'
      preLoaderRoute: typeof UnderReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth-layout': {
      id: '/_auth-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/terms-and-conditions': {
      id: '/(public)/terms-and-conditions'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions'
      preLoaderRoute: typeof publicTermsAndConditionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/privacy-policy': {
      id: '/(public)/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof publicPrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/(private)/profile': {
      id: '/_layout/(private)/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof LayoutprivateProfileRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/my-statements': {
      id: '/_layout/(private)/my-statements'
      path: '/my-statements'
      fullPath: '/my-statements'
      preLoaderRoute: typeof LayoutprivateMyStatementsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/home': {
      id: '/_layout/(private)/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof LayoutprivateHomeRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_auth-layout/(auth)/sign-in': {
      id: '/_auth-layout/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthLayoutauthSignInRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_auth-layout/(auth)/register': {
      id: '/_auth-layout/(auth)/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthLayoutauthRegisterRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_auth-layout/(auth)/forgot-password': {
      id: '/_auth-layout/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthLayoutauthForgotPasswordRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_layout/(private)/treatments/': {
      id: '/_layout/(private)/treatments/'
      path: '/treatments'
      fullPath: '/treatments'
      preLoaderRoute: typeof LayoutprivateTreatmentsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/new-treatments/': {
      id: '/_layout/(private)/new-treatments/'
      path: '/new-treatments'
      fullPath: '/new-treatments'
      preLoaderRoute: typeof LayoutprivateNewTreatmentsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/new-medications/': {
      id: '/_layout/(private)/new-medications/'
      path: '/new-medications'
      fullPath: '/new-medications'
      preLoaderRoute: typeof LayoutprivateNewMedicationsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/my-treatments/': {
      id: '/_layout/(private)/my-treatments/'
      path: '/my-treatments'
      fullPath: '/my-treatments'
      preLoaderRoute: typeof LayoutprivateMyTreatmentsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/my-medications/': {
      id: '/_layout/(private)/my-medications/'
      path: '/my-medications'
      fullPath: '/my-medications'
      preLoaderRoute: typeof LayoutprivateMyMedicationsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/medications/': {
      id: '/_layout/(private)/medications/'
      path: '/medications'
      fullPath: '/medications'
      preLoaderRoute: typeof LayoutprivateMedicationsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/treatments/$id': {
      id: '/_layout/(private)/treatments/$id'
      path: '/treatments/$id'
      fullPath: '/treatments/$id'
      preLoaderRoute: typeof LayoutprivateTreatmentsIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/new-treatments/$id': {
      id: '/_layout/(private)/new-treatments/$id'
      path: '/new-treatments/$id'
      fullPath: '/new-treatments/$id'
      preLoaderRoute: typeof LayoutprivateNewTreatmentsIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/new-medications/$id': {
      id: '/_layout/(private)/new-medications/$id'
      path: '/new-medications/$id'
      fullPath: '/new-medications/$id'
      preLoaderRoute: typeof LayoutprivateNewMedicationsIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/medications/$id': {
      id: '/_layout/(private)/medications/$id'
      path: '/medications/$id'
      fullPath: '/medications/$id'
      preLoaderRoute: typeof LayoutprivateMedicationsIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/my-treatments/$id/new-details': {
      id: '/_layout/(private)/my-treatments/$id/new-details'
      path: '/my-treatments/$id/new-details'
      fullPath: '/my-treatments/$id/new-details'
      preLoaderRoute: typeof LayoutprivateMyTreatmentsIdNewDetailsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/my-treatments/$id/edit-details': {
      id: '/_layout/(private)/my-treatments/$id/edit-details'
      path: '/my-treatments/$id/edit-details'
      fullPath: '/my-treatments/$id/edit-details'
      preLoaderRoute: typeof LayoutprivateMyTreatmentsIdEditDetailsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/my-medications/$id/new-details': {
      id: '/_layout/(private)/my-medications/$id/new-details'
      path: '/my-medications/$id/new-details'
      fullPath: '/my-medications/$id/new-details'
      preLoaderRoute: typeof LayoutprivateMyMedicationsIdNewDetailsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/my-medications/$id/edit-details': {
      id: '/_layout/(private)/my-medications/$id/edit-details'
      path: '/my-medications/$id/edit-details'
      fullPath: '/my-medications/$id/edit-details'
      preLoaderRoute: typeof LayoutprivateMyMedicationsIdEditDetailsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/my-treatments/$id/new/': {
      id: '/_layout/(private)/my-treatments/$id/new/'
      path: '/my-treatments/$id/new'
      fullPath: '/my-treatments/$id/new'
      preLoaderRoute: typeof LayoutprivateMyTreatmentsIdNewIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/my-treatments/$id/edit/': {
      id: '/_layout/(private)/my-treatments/$id/edit/'
      path: '/my-treatments/$id/edit'
      fullPath: '/my-treatments/$id/edit'
      preLoaderRoute: typeof LayoutprivateMyTreatmentsIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/my-medications/$id/new/': {
      id: '/_layout/(private)/my-medications/$id/new/'
      path: '/my-medications/$id/new'
      fullPath: '/my-medications/$id/new'
      preLoaderRoute: typeof LayoutprivateMyMedicationsIdNewIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/(private)/my-medications/$id/edit/': {
      id: '/_layout/(private)/my-medications/$id/edit/'
      path: '/my-medications/$id/edit'
      fullPath: '/my-medications/$id/edit'
      preLoaderRoute: typeof LayoutprivateMyMedicationsIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
  }
}

interface AuthLayoutRouteChildren {
  AuthLayoutauthForgotPasswordRoute: typeof AuthLayoutauthForgotPasswordRoute
  AuthLayoutauthRegisterRoute: typeof AuthLayoutauthRegisterRoute
  AuthLayoutauthSignInRoute: typeof AuthLayoutauthSignInRoute
}

const AuthLayoutRouteChildren: AuthLayoutRouteChildren = {
  AuthLayoutauthForgotPasswordRoute: AuthLayoutauthForgotPasswordRoute,
  AuthLayoutauthRegisterRoute: AuthLayoutauthRegisterRoute,
  AuthLayoutauthSignInRoute: AuthLayoutauthSignInRoute,
}

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(
  AuthLayoutRouteChildren,
)

interface LayoutRouteChildren {
  LayoutprivateHomeRoute: typeof LayoutprivateHomeRoute
  LayoutprivateMyStatementsRoute: typeof LayoutprivateMyStatementsRoute
  LayoutprivateProfileRoute: typeof LayoutprivateProfileRoute
  LayoutprivateMedicationsIdRoute: typeof LayoutprivateMedicationsIdRoute
  LayoutprivateNewMedicationsIdRoute: typeof LayoutprivateNewMedicationsIdRoute
  LayoutprivateNewTreatmentsIdRoute: typeof LayoutprivateNewTreatmentsIdRoute
  LayoutprivateTreatmentsIdRoute: typeof LayoutprivateTreatmentsIdRoute
  LayoutprivateMedicationsIndexRoute: typeof LayoutprivateMedicationsIndexRoute
  LayoutprivateMyMedicationsIndexRoute: typeof LayoutprivateMyMedicationsIndexRoute
  LayoutprivateMyTreatmentsIndexRoute: typeof LayoutprivateMyTreatmentsIndexRoute
  LayoutprivateNewMedicationsIndexRoute: typeof LayoutprivateNewMedicationsIndexRoute
  LayoutprivateNewTreatmentsIndexRoute: typeof LayoutprivateNewTreatmentsIndexRoute
  LayoutprivateTreatmentsIndexRoute: typeof LayoutprivateTreatmentsIndexRoute
  LayoutprivateMyMedicationsIdEditDetailsRoute: typeof LayoutprivateMyMedicationsIdEditDetailsRoute
  LayoutprivateMyMedicationsIdNewDetailsRoute: typeof LayoutprivateMyMedicationsIdNewDetailsRoute
  LayoutprivateMyTreatmentsIdEditDetailsRoute: typeof LayoutprivateMyTreatmentsIdEditDetailsRoute
  LayoutprivateMyTreatmentsIdNewDetailsRoute: typeof LayoutprivateMyTreatmentsIdNewDetailsRoute
  LayoutprivateMyMedicationsIdEditIndexRoute: typeof LayoutprivateMyMedicationsIdEditIndexRoute
  LayoutprivateMyMedicationsIdNewIndexRoute: typeof LayoutprivateMyMedicationsIdNewIndexRoute
  LayoutprivateMyTreatmentsIdEditIndexRoute: typeof LayoutprivateMyTreatmentsIdEditIndexRoute
  LayoutprivateMyTreatmentsIdNewIndexRoute: typeof LayoutprivateMyTreatmentsIdNewIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutprivateHomeRoute: LayoutprivateHomeRoute,
  LayoutprivateMyStatementsRoute: LayoutprivateMyStatementsRoute,
  LayoutprivateProfileRoute: LayoutprivateProfileRoute,
  LayoutprivateMedicationsIdRoute: LayoutprivateMedicationsIdRoute,
  LayoutprivateNewMedicationsIdRoute: LayoutprivateNewMedicationsIdRoute,
  LayoutprivateNewTreatmentsIdRoute: LayoutprivateNewTreatmentsIdRoute,
  LayoutprivateTreatmentsIdRoute: LayoutprivateTreatmentsIdRoute,
  LayoutprivateMedicationsIndexRoute: LayoutprivateMedicationsIndexRoute,
  LayoutprivateMyMedicationsIndexRoute: LayoutprivateMyMedicationsIndexRoute,
  LayoutprivateMyTreatmentsIndexRoute: LayoutprivateMyTreatmentsIndexRoute,
  LayoutprivateNewMedicationsIndexRoute: LayoutprivateNewMedicationsIndexRoute,
  LayoutprivateNewTreatmentsIndexRoute: LayoutprivateNewTreatmentsIndexRoute,
  LayoutprivateTreatmentsIndexRoute: LayoutprivateTreatmentsIndexRoute,
  LayoutprivateMyMedicationsIdEditDetailsRoute:
    LayoutprivateMyMedicationsIdEditDetailsRoute,
  LayoutprivateMyMedicationsIdNewDetailsRoute:
    LayoutprivateMyMedicationsIdNewDetailsRoute,
  LayoutprivateMyTreatmentsIdEditDetailsRoute:
    LayoutprivateMyTreatmentsIdEditDetailsRoute,
  LayoutprivateMyTreatmentsIdNewDetailsRoute:
    LayoutprivateMyTreatmentsIdNewDetailsRoute,
  LayoutprivateMyMedicationsIdEditIndexRoute:
    LayoutprivateMyMedicationsIdEditIndexRoute,
  LayoutprivateMyMedicationsIdNewIndexRoute:
    LayoutprivateMyMedicationsIdNewIndexRoute,
  LayoutprivateMyTreatmentsIdEditIndexRoute:
    LayoutprivateMyTreatmentsIdEditIndexRoute,
  LayoutprivateMyTreatmentsIdNewIndexRoute:
    LayoutprivateMyTreatmentsIdNewIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthLayoutRoute: AuthLayoutRouteWithChildren,
  LayoutRoute: LayoutRouteWithChildren,
  UnderReviewRoute: UnderReviewRoute,
  publicPrivacyPolicyRoute: publicPrivacyPolicyRoute,
  publicTermsAndConditionsRoute: publicTermsAndConditionsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
